import React, { useRef, useState, useEffect } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import axios from "axios";
import moment from "moment";
import { ModalDeudaTimbre } from "./modaldeudatimbre";
import { cmes } from "../../util/varios";

const TablaDeudaTimbre = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");
  let anioActu = JSON.parse(localStorage.getItem("anioactu"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-minus">
          {" "}
          AÑO
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          MES
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: <i style={{ textAlign: "center" }}> PERIODO</i>,
      textAlign: "center",
      fontFamily: "georgia",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-date">
          {" "}
          FECHA
        </i>
      ),
      textAlign: "center",
      fontFamily: "georgia",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [anio, setAnio] = useState([]);
  const [anios, setAnios] = useState();
  const [vanios, setVanios] = useState(anioActu);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [fechas, setFechas] = useState();
  const [mes, setMes] = useState();
  const txtAnio = useRef();
  const [operacion, setOperacion] = useState(1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.mes.toLowerCase().includes(target.value.toLowerCase()) ||
              moment(x.fechasis).format("DD/MM/YYYY").includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const SeleccionarRegistros = (anio) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "periodostimbres";
    let nomid = "tipoplanilla";
    let id = props.tipo;

    let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var datos = [];
          var enero = "ENERO";
          var febrero = "FEBRERO";
          var marzo = "MARZO";
          var abril = "ABRIL";
          var mayo = "MAYO";
          var junio = "JUNIO";
          var julio = "JULIO";
          var agosto = "AGOSTO";
          var septiembre = "SEPTIEMBRE";
          var octubre = "OCTUBRE";
          var noviembre = "NOVIEMBRE";
          var diciembre = "DICIEMBRE";
          var mess;
          var anio;
          var mesa;

          for (let i = 0; i < response.data.length; i++) {
            anio = response.data[i].anio;
            mesa = response.data[i].mes;

            if (response.data[i].mes === 1) {
              mess = enero;
            } else if (response.data[i].mes === 2) {
              mess = febrero;
            } else if (response.data[i].mes === 3) {
              mess = marzo;
            } else if (response.data[i].mes === 4) {
              mess = abril;
            } else if (response.data[i].mes === 5) {
              mess = mayo;
            } else if (response.data[i].mes === 6) {
              mess = junio;
            } else if (response.data[i].mes === 7) {
              mess = julio;
            } else if (response.data[i].mes === 8) {
              mess = agosto;
            } else if (response.data[i].mes === 9) {
              mess = septiembre;
            } else if (response.data[i].mes === 10) {
              mess = octubre;
            } else if (response.data[i].mes === 11) {
              mess = noviembre;
            } else if (response.data[i].mes === 12) {
              mess = diciembre;
            }

            datos.push({
              fechasis: response.data[i].fechasis,
              mes: mess,
              anio: anio,
              mesa: mesa,
              tipo: response.data[i].tipo,
              periodo: response.data[i].periodo,
            });
          }
          setRecords(datos);
          setAnios(anio);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarRegistro = (anio, mes) => {
    let campos = "*";
    let nomtab = "fechavencimientoprod";
    let nomid = "anio";
    let nomid2 = "mes";
    let orden = "mes";

    let endpoint = `${op.conexion}/api/consulta/idsstring2rows?&campos=${campos}&id=${anio}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${mes}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setFechas(response.data);
            setMostrar2(true);
          } else {
            setMostrar2(true);
          }

          let mesf;
          if (response.data[0].mes === "1") {
            mesf = "ENERO";
          } else if (response.data[0].mes === "2") {
            mesf = "FEBRERO";
          } else if (response.data[0].mes === "3") {
            mesf = "MARZO";
          } else if (response.data[0].mes === "4") {
            mesf = "ABRIL";
          } else if (response.data[0].mes === "5") {
            mesf = "MAYO";
          } else if (response.data[0].mes === "6") {
            mesf = "JUNIO";
          } else if (response.data[0].mes === "7") {
            mesf = "JULIO";
          } else if (response.data[0].mes === "8") {
            mesf = "AGOSTO";
          } else if (response.data[0].mes === "9") {
            mesf = "SEPTIEMBRE";
          } else if (response.data[0].mes === "10") {
            mesf = "OCTUBRE";
          } else if (response.data[0].mes === "11") {
            mesf = "NOVIEMBRE";
          } else if (response.data[0].mes === "12") {
            mesf = "DICIEMBRE";
          }
          setMes(mesf);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const ActuFechas = (op, anio, mes) => (e) => {
    blanquear();
    if (op === 4) {
      setOperacion(4);
      seleccionarRegistro(anio, mes);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      seleccionarRegistro(anio, mes);
    } else if (op === 3) {
      setOperacion(op);
      seleccionarRegistro(anio, mes);
    }
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const blanquear = () => {
    setFechas();
    setMes();
  };

  const anioselect = (e) => {
    let a = parseInt(e.target.value);

    setVanios(a);
    SeleccionarRegistros(a);
  };

  useEffect(() => {
    var nanio = [];
    var aini = parseInt(anioActu) - 7;
    var afin = parseInt(anioActu);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);

    SeleccionarRegistros(anioActu);
  }, []);

  return (
    <div className="h-100 w-100">
      <div className="h-2 p-4"></div>
      <div className="row card col-md-7 mx-auto amanecergris">
        <div className="col-md-12 p-2">
          <div className="row col-md-12 d-flex justify-content-between">
            <input
              type="text"
              className=" col-3 form-control form-control-sm rounded-pill"
              onChange={handleSearch}
              placeholder="Buscar"
            />
            {/*             <div className='col-3'>
              <div className="input-group input-group-sm">
                <label className="input-group-text" id="inputGroup-sizing-sm" style={{ backgroundColor: "#55acee" }}>Año:</label>
                <select name="anios" ref={txtAnio} onChange={anioselect} className="form-control">
                  {anio && anio.map((a, index) => (
                    <option key={index} value={a.anio}>{a.anio}</option>
                  ))}
                </select>
              </div>
            </div> */}
            <div className="col-3 d-flex justify-content-end">
              <button
                onClick={ActuFechas(1, "")}
                className="btn btn-sm btn-primary rounded-circle"
              >
                <i className="fas fa-plus"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="m-0">
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{ padding: "0", backgroundColor: "#fff" }}
                  >
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {item.anio}
                    </TableCell>
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {item.mes}
                    </TableCell>
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {item.periodo}
                    </TableCell>
                    <TableCell
                      style={{ textAlign: "center", fontFamily: "georgia" }}
                    >
                      {moment(item.fechasis).format("DD/MM/YYYY")}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>

        <ModalDeudaTimbre
          show={mostrar2}
          operacion={operacion}
          fechas={fechas}
          mesf={mes}
          anios={vanios}
          tipo={props.tipo}
          onHideRenderizar={SeleccionarRegistros}
          onHideCancela={handleCancela2}
        />
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaDeudaTimbre;



// WEBPACK FOOTER //
// ./src/components/timbres/deudatimbre.js